import React, { useEffect, useState } from "react";
import {
  Select,
  MenuItem,
  Tabs,
  Tab,
  Box,
  FormControl,
  InputLabel,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  SelectChangeEvent,
  Avatar,
} from "@mui/material";
import {useSchedule} from "../../contexts/ScheduleContext";
interface Props {
  name: string;
}

const StyledContent = styled("div")(({ theme }) => ({
  padding: theme.spacing(3),
  color: theme.palette.text.primary,
}));

export const Standings = (props: Props) => {
  const { standings, fetchStandings } = useSchedule();
  const [division, setDivision] = useState(1);

  const divisionOneStandings = standings.filter(
    (standing) => standing.club.football_division === "1"
  );
  const divisionTwoStandings = standings.filter(
    (standing) => standing.club.football_division === "2"
  );

  const currentStandings = divisionTwoStandings
    ? divisionTwoStandings
    : divisionOneStandings;

  const handleDivisionChange = (
    _event: React.SyntheticEvent,
    newValue: number
  ) => {
    setDivision(newValue);
  };

  const renderStandingsTable = () => {
    return (
      <TableContainer component={Paper} sx={{ bgcolor: "background.paper", maxWidth: 1200 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: '40%', fontSize: '1rem' }}>Team</TableCell>
              <TableCell align="right" sx={{ width: '8%', fontSize: '1rem' }}>Wins</TableCell>
              <TableCell align="right" sx={{ width: '8%', fontSize: '1rem' }}>Losses</TableCell>
              <TableCell align="right" sx={{ width: '8%', fontSize: '1rem' }}>Ties</TableCell>
              <TableCell align="right" sx={{ width: '8%', fontSize: '1rem' }}>Pct</TableCell>
              <TableCell align="right" sx={{ width: '8%', fontSize: '1rem' }}>PF</TableCell>
              <TableCell align="right" sx={{ width: '8%', fontSize: '1rem' }}>PA</TableCell>
              <TableCell align="right" sx={{ width: '8%', fontSize: '1rem' }}>Home</TableCell>
              <TableCell align="right" sx={{ width: '8%', fontSize: '1rem' }}>Away</TableCell>
              <TableCell align="right" sx={{ width: '8%', fontSize: '1rem' }}>Streak</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentStandings.map((standing) => (
              <TableRow
                key={standing.club.id}
                sx={{
                  "&:last-child td, &:last-child th": {
                    border: 0,
                  },
                  backgroundColor:
                    standing.club.name === "St. Anne's-Belfield School"
                      ? "#000000"
                      : "inherit",
                  "&:hover": {
                    backgroundColor: "action.hover",
                    cursor: "pointer",
                  },
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  style={{ fontWeight: "bold" }}
                  sx={{ width: '25%', maxWidth: '250px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '1rem' }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Avatar
                      src={standing.club.profile_picture}
                      alt={standing.club.name}
                      sx={{ width: 24, height: 24 }}
                    />
                    {standing.club.name}
                  </Box>
                </TableCell>
                <TableCell align="right" sx={{ width: '7%' }}>{standing.wins}</TableCell>
                <TableCell align="right" sx={{ width: '7%' }}>{standing.losses}</TableCell>
                <TableCell align="right" sx={{ width: '7%' }}>{standing.ties}</TableCell>
                <TableCell align="right" sx={{ width: '7%' }}>{standing.pct.toFixed(3)}</TableCell>
                <TableCell align="right" sx={{ width: '7%' }}>{standing.points_for}</TableCell>
                <TableCell align="right" sx={{ width: '7%' }}>{standing.points_against}</TableCell>
                <TableCell align="right" sx={{ width: '10%' }}>{standing.home_record}</TableCell>
                <TableCell align="right" sx={{ width: '10%' }}>{standing.away_record}</TableCell>
                <TableCell align="right" sx={{ width: '10%' }}>{standing.streak}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <StyledContent>
      <>
        <Box
          sx={{
            mb: 3,
            display: "flex",
            justifyContent: "flex-start",
            "& .MuiInputLabel-root": {
              color: "text.secondary",
            },
            "& .MuiOutlinedInput-root": {
              color: "text.primary",
            },
            maxWidth: 1000,
            width: '100%',
          }}
        >
        </Box>
        
        <Box sx={{ mb: 3, textAlign: "center", maxWidth: 1000, width: '100%' }}>
          <h2>{props.name} Standings</h2>
        </Box>

        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            "& .MuiTabs-indicator": {
              backgroundColor: "primary.main",
            },
            maxWidth: 1000,
            width: '100%',
          }}
        >
          <Tabs
            value={division}
            onChange={handleDivisionChange}
            centered
            sx={{
              "& .MuiTab-root": {
                color: "text.secondary",
                "&.Mui-selected": {
                  color: "text.primary",
                },
              },
            }}
          >
            <Tab label="DIVISION I" />
            <Tab label="DIVISION II" />
          </Tabs>
        </Box>
      </>
      <Box sx={{ mt: 3 }}>{renderStandingsTable()}</Box>
    </StyledContent>
  );
};
